/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Invite_SubtitleInputs */

const en_team_invite_subtitle = /** @type {(inputs: Team_Invite_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send an invite by email, they'll receive access once they accept.`)
};

const es_team_invite_subtitle = /** @type {(inputs: Team_Invite_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envía una invitación por correo, recibirán acceso cuando la acepten.`)
};

const fr_team_invite_subtitle = /** @type {(inputs: Team_Invite_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyez une invitation par e-mail, ils recevront l'accès une fois acceptée.`)
};

const de_team_invite_subtitle = /** @type {(inputs: Team_Invite_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sende eine Einladung per E-Mail, sie erhalten Zugang, sobald sie akzeptieren.`)
};

const id_team_invite_subtitle = /** @type {(inputs: Team_Invite_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirim undangan melalui email — mereka akan menerima akses setelah menyetujui.`)
};

/** @type {(inputs: Team_Invite_SubtitleInputs) => LocalizedString} */
const ja_team_invite_subtitle = en_team_invite_subtitle;

/** @type {(inputs: Team_Invite_SubtitleInputs) => LocalizedString} */
const zh_team_invite_subtitle = en_team_invite_subtitle;

/** @type {(inputs: Team_Invite_SubtitleInputs) => LocalizedString} */
const ar_team_invite_subtitle = en_team_invite_subtitle;

/** @type {(inputs: Team_Invite_SubtitleInputs) => LocalizedString} */
const it_team_invite_subtitle = en_team_invite_subtitle;

/** @type {(inputs: Team_Invite_SubtitleInputs) => LocalizedString} */
const ru_team_invite_subtitle = en_team_invite_subtitle;

/** @type {(inputs: Team_Invite_SubtitleInputs) => LocalizedString} */
const pt_team_invite_subtitle = en_team_invite_subtitle;

/** @type {(inputs: Team_Invite_SubtitleInputs) => LocalizedString} */
const ko_team_invite_subtitle = en_team_invite_subtitle;

/**
* | output |
* | --- |
* | "Send an invite by email, they'll receive access once they accept." |
*
* @param {Team_Invite_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const team_invite_subtitle = /** @type {((inputs?: Team_Invite_SubtitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Invite_SubtitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_team_invite_subtitle(inputs)
	if (locale === "es") return es_team_invite_subtitle(inputs)
	if (locale === "fr") return fr_team_invite_subtitle(inputs)
	if (locale === "de") return de_team_invite_subtitle(inputs)
	if (locale === "ja") return ja_team_invite_subtitle(inputs)
	if (locale === "zh") return zh_team_invite_subtitle(inputs)
	if (locale === "ar") return ar_team_invite_subtitle(inputs)
	if (locale === "id") return id_team_invite_subtitle(inputs)
	if (locale === "it") return it_team_invite_subtitle(inputs)
	if (locale === "ru") return ru_team_invite_subtitle(inputs)
	if (locale === "pt") return pt_team_invite_subtitle(inputs)
	return ko_team_invite_subtitle(inputs)
});